export enum MessageType{
    Success = 'Success',
    Error = 'Error',
    Info = 'Info',
    Warn = 'Warn'
}
